import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Motion";
import { TEAM } from "../data";

export default function Team() {
  return (
    <div data-testid="team-page">
      <PageIntro
        label="Leadership & Advisors"
        title="Decades of mining, geoscience and finance expertise."
        subtitle="A leadership team uniting mineral exploration, resource assessment, project development and capital markets."
      />

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={(i % 2) * 0.1}>
              <div data-testid={`team-card-${i}`} className="group h-full flex flex-col sm:flex-row gap-6 p-6 bg-white border border-mm-line rounded-lg shadow-card hover:shadow-cardHover transition-all duration-300">
                <div className="w-full sm:w-40 shrink-0 self-start aspect-[3/4] rounded-md overflow-hidden bg-mm-light">
                  <img src={m.image} alt={m.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="flex-1 flex flex-col">
                  <h3 className="font-display font-bold text-xl text-mm-ink">{m.name}</h3>
                  <p className="text-mm-blue font-semibold text-sm mt-1">{m.role}</p>
                  <p className="font-mono text-[0.62rem] tracking-[0.12em] uppercase text-mm-muted mt-2">{m.focus}</p>
                  <p className="text-mm-muted leading-relaxed mt-4 text-[0.95rem]">{m.bio}</p>
                  {m.highlights && (
                    <ul className="mt-4 space-y-2">
                      {m.highlights.map((h) => (
                        <li key={h} className="flex items-start gap-2.5 text-[0.9rem] text-mm-muted">
                          <span className="h-1.5 w-1.5 rounded-full bg-mm-accent shrink-0 mt-2" />
                          <span>{h}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
